import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { itIT } from '@mui/x-data-grid/locales';

export default function CardsTable({ cardsData }) {
  const cardColumns = [
    { field: 'campaign', headerName: 'Campagna di tesseramento', editable: false, hideable: false, flex: 0.5 },
    { field: 'fiscal_code', headerName: 'Codice Fiscale', editable: false, hideable: false, flex: 1 },
    { field: 'master_entity', headerName: 'Entità pagamento', editable: false, flex: 1 },
    { field: 'payment_type', headerName: 'Tipo di pagamento', editable: false, flex: 1 },
    { field: 'payment_status', headerName: 'Stato di pagamento', editable: false, flex: 1 },
    {
      field: 'free_rate',
      headerName: 'Quota extra volontaria',
      valueFormatter: (value) => (value ? `${value} €` : ''),
      editable: false,
      hideable: false,
      flex: 1,
    },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarExport csvOptions={{ allColumns: true }} printOptions={{ disableToolbarButton: true }} />
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <DataGrid
        disableRowSelectionOnClick
        rows={cardsData}
        columns={cardColumns}
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) => row.fiscal_code}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        pageSizeOptions={[10]}
        initialState={{
          ...cardsData.initialState,
          pagination: { paginationModel: { pageSize: 10 } },

          columns: {
            ...cardsData.initialState?.columns,
          },
        }}
      />
    </>
  );
}
